import { combineReducers, createStore } from "redux";
import storage from 'redux-persist/lib/storage';
import { persistReducer, persistStore } from 'redux-persist';
import thunk from 'redux-thunk';
import mandateReducer from './Components/MandateSlice'
import { configureStore } from "@reduxjs/toolkit";

// const persistConfig = {
//   key: 'root',
//   storage,
// }

// const persistedReducer = persistReducer(persistConfig, mandateReducer)

// export const store = configureStore({
//   reducer: persistedReducer,
//   devTools: process.env.NODE_ENV !== 'production',
//   middleware: [thunk]
// })
// export const persistor = persistStore(store)
const combinedReducer = combineReducers({
  mandateInfo : mandateReducer
 })

 const rootReducer = (state, action) => {
  return combinedReducer(state, action);
};

 export const store = configureStore({
  reducer: rootReducer,
  middleware: [thunk],
});